import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import EmptyState from '../shared/components/EmptyState';
import Skeleton from '../shared/components/Skeleton';
import StatusPill from '../shared/components/StatusPill';
import { date, invoiceTotal, money } from '../shared/formatters';
import PortalHeader from './PortalHeader';

export default function Invoices() {
  const { data } = useData();
  const { client, base } = usePortalClient();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 200);
    return () => clearTimeout(timer);
  }, []);

  const invoices = useMemo(
    () => data.invoices.filter((item) => item.client_id === client.id),
    [client.id, data.invoices]
  );

  if (loading) {
    return <Skeleton rows={4} />;
  }

  return (
    <>
      <PortalHeader
        eyebrow="Documents & payments"
        title="Your invoices"
        description="View invoice history and download copies for your records."
      />

      {!invoices.length ? (
        <EmptyState title="No invoices yet" message="Invoices for completed work will appear here." />
      ) : (
        <section className="portal-card no-padding invoice-list">
          {invoices.map((invoice) => (
            <Link
              to={`${base}/invoices/${invoice.id}`}
              key={invoice.id}
            >
              <div>
                <strong>{invoice.number}</strong>
                <span>{invoice.title}</span>
              </div>
              <span>Due {date(invoice.due_date)}</span>
              <strong>{money(invoiceTotal(invoice))}</strong>
              <StatusPill invoice={invoice} />
            </Link>
          ))}
        </section>
      )}
    </>
  );
}